export enum UserProfile {
    Admin = "Admin",
    Viewer = "Viewer"
}

export class LoggedUser {
    id: string;
    profile: UserProfile;
    token: string;
}